import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const deviceSetupOptions = Loadable(() => import('../../containers/web/deviceSetupOptions'));
export default MapTo('vcg/components/soe-home/react/deviceSetupOptions')(deviceSetupOptions);
